import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { usePrefersReducedMotion } from './motion';
type CalendarVisualProps = {
  mode: 'reschedule' | 'selfBook';
  heading: string;
};
const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

/* A small week grid used two ways on What It Fixes: "reschedule" shows a
   booked slot moving from a conflicted day to an open one (appointment
   reminders + rescheduling); "selfBook" shows an empty slot filling itself
   in as a customer picks it (book into your calendar themselves). Same
   grid, same motion language as the rest of components/visuals -- dashed
   connectors, emerald fill, framer-motion whileInView, reduced-motion safe. */
export function CalendarVisual({
  mode,
  heading
}: CalendarVisualProps) {
  const reducedMotion = usePrefersReducedMotion();
  return <div className="w-full overflow-hidden rounded-2xl border border-[#1c1c1c] bg-[#0a0a0a] p-6" data-id="element-723" data-mp="1qr5v7a9gq49l">
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-neutral-500" data-id="element-724" data-mp="1lpgna3hje6pq">
        {heading}
      </p>

      <div className="mt-5 grid grid-cols-5 gap-2" data-id="element-725" data-mp="27dd2cinhu8dv">
        {days.map((day, di) => <div key={day} className="flex flex-col items-center gap-2" data-id="element-726" data-mp="2cc7voej37fc8" data-mpi={di}>
            <span className="font-mono text-[10px] uppercase tracking-[0.1em] text-neutral-600" data-id="element-727" data-mp="1xgi84by96u5e">
              {day}
            </span>
            <div className="flex h-24 w-full flex-col gap-1.5 rounded-lg border border-[#1c1c1c] bg-[#0d0d0d] p-1.5" data-id="element-728" data-mp="22hxv49jzraqf">
              {[0, 1, 2].map(slot => {
            const isTarget = mode === 'reschedule' ? di === 3 && slot === 1 : di === 2 && slot === 1;
            const isVacatedSource = mode === 'reschedule' && di === 0 && slot === 1;
            return <motion.div key={slot} initial={reducedMotion ? false : isTarget ? {
              opacity: 0,
              scale: 0.85
            } : {
              opacity: 1
            }} whileInView={isTarget ? {
              opacity: 1,
              scale: 1
            } : isVacatedSource ? {
              opacity: [1, 0.25],
              borderStyle: 'dashed'
            } : {}} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.5,
              delay: 0.5
            }} className={`flex h-full items-center justify-center rounded ${isTarget ? 'bg-emerald-500/20 ring-1 ring-emerald-500/50' : isVacatedSource ? 'border border-dashed border-neutral-700' : 'bg-[#161616]'}`} data-id="element-729" data-mp="15plxlhzo11la">
                    {isTarget && <CheckIcon className="h-3 w-3 text-emerald-500" aria-hidden="true" data-id="element-730" data-mp="260etp53z8wh3" />}
                  </motion.div>;
          })}
            </div>
          </div>)}
      </div>

      <p className="mt-4 text-xs text-neutral-600" data-id="element-731" data-mp="ugy04ixeawjg">
        {mode === 'reschedule' ? 'Conflict on Monday, moved to Thursday. Both sides got a text.' : 'Wednesday, 1pm booked itself off the link you sent once.'}
      </p>
    </div>;
}